import React, { useRef, useState } from "react";
import classnames from "classnames";
import { message, Modal } from "antd";

import styles from "./index.module.less";
import { IWriteCommentProps } from "../types";
import { fetchCommentAdd } from "../../../services/article";
import { ECommentType } from "@Types/constants";
import { isEmptyString } from "../../../utils/dataHandler";
import NewLoginModel from "../NewLoginModel";

const info = (info: string) => {
  message.info(info);
};

const success = (success: string) => {
  message.success(success);
};

const WriteComment = (props: IWriteCommentProps) => {
  const {
    size = "large",
    placeholder = "發佈你的看法吧",
    stylesMargin,
    stylesArea,
    type,
    re_id,
    re_mid,
    isSign,
    id,
    response,
  } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [value, setValue] = useState("");

  let textarea_classnames = classnames({
    "textarea-large": size == "large",
    "textarea-small": size == "small",
  });

  let isIframeComment = classnames("IframeWriteComment");

  /** 发送评论 */
  const sendComment = async () => {
    const params: any = {
      type: type as ECommentType,
      id: String(id),
      reId: re_id,
      reMid: re_mid,
      content: value,
      // token: localStorage.getItem("accesstoken"),
    };
    const result = (await fetchCommentAdd({ ...params })) as any;

    if (result.status == 12000) {
      success("評論成功");
      setValue("");
      if (response) {
        response(result);
      }
    } else {
      message.error(result?.data?.message ?? result?.error?.message);
    }
  };

  const openSignWindow = () => {
    const el = document.getElementById("iframe-base-sigin");
    if (el) {
      el.style.display = "block";
    }
  };

  const handleCheckLoginStatus = () => {
    if (!isSign) {
      openSignWindow();
    }
  };

  return (
    <section className={styles[isIframeComment]} style={stylesMargin}>
      <textarea
        className={styles[textarea_classnames]}
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        onClick={handleCheckLoginStatus}
        style={stylesArea}
      />
      <button
        className={styles["send-btn"]}
        style={{ border: "none", background: !value ? "#bbb" : "#3264ff" }}
        onClick={() => {
          if (!value) {
            info("評論內容不能為空");
            return;
          }

          setModalOpen(true);
        }}
      >
        發佈
      </button>

      <NewLoginModel
        title='發佈評論，與更多用戶交流互動！'
        desc='立即登入，用戶回覆後將同步您'
        visible={modalOpen}
        onClose={() => {
          info("您已取消登錄，將以遊客身份發佈評論");
        }}
        setVisible={(status) => {
          sendComment();
          setModalOpen(status);
        }}
      />
    </section>
  );
};

export default WriteComment;
